export default "__VITE_ASSET__DPQu8Vzg__"